<template>
  <div>
    <span>{{ $filters.fullname(object) }}</span>
  </div>
</template>

<script>

export default {
  name: "UserResultRow",
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
};
</script>
